import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Row, Spinner } from 'react-bootstrap';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useHistory, useParams } from 'react-router-dom';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import snakecaseKeys from 'snakecase-keys';
import camelCaseRecursive from 'camelcase-keys-recursive';
import { Icon } from '../../components';
import { SettlementGroupBalances, SettlementGroupForm } from './SettlementGroup';
import initialValues from './SettlementGroup/Form/InitialValues';
import {
  createSettlementGroupRequest,
  updateSettlementGroupRequest,
  showSettlementGroupRequest
} from '../../requests/payrollSettlementGroup';
import { sendAlert } from '../../actions/utils';
import prepareSettlementGroupToSave from './SettlementGroup/helpers/helpers';

export default function() {
  const [step, setStep] = useState(0);
  const [settlementGroup, setSettlementGroup] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { currentCompany } = useSelector(state => state.auth);
  const { id: settlementGroupID } = useParams();
  const dispatch = useDispatch();

  const history = useHistory();

  const componentMapping = {
    0: SettlementGroupForm,
    1: SettlementGroupBalances
  };

  const validationSchema = ({ currentStage }) => {
    if (currentStage === 0) {
      return Yup.object().shape({
        settlementGroup: Yup.object().shape({
          issueDate: Yup.string()
            .required('Debes especificar una fecha de emisión')
            .test('issueDate', 'La fecha de emisión debe ser mayor o igual a la fecha de término', function(value) {
              const issueDate = moment(value, 'DD/MM/YYYY');
              const endDate = moment(this.parent?.endDate, 'DD/MM/YYYY');
              return issueDate.isSameOrAfter(endDate);
            }),
          endDate: Yup.string().required('Debes especificar una fecha de término'),
          name: Yup.string().required('Debes especificar un nombre'),
          terminationReason: Yup.number().required('Debes seleccionar un motivo de término')
        })
      });
    }
    return Yup.object().shape({});
  };

  const fetchSettlementGroup = useCallback(() => {
    if (!settlementGroupID) return;
    setIsLoading(true);
    showSettlementGroupRequest(settlementGroupID, {
      dispatch,
      params: {
        form: true
      },
      successCallback: ({ data }) => {
        setSettlementGroup(camelCaseRecursive(data));
        setIsLoading(false);
      },
      callback: () => setIsLoading(false)
    });
  }, [dispatch, settlementGroupID]);

  const formRequest = (values, { setSubmitting }, currentStep) => {
    const formatedValues = prepareSettlementGroupToSave(values, currentCompany.id);
    const newValues = snakecaseKeys(formatedValues, { exclude: ['_destroy'] });
    const payload = {
      dispatch,
      params: { ...newValues }
    };
    if (settlementGroup.id) {
      payload.successCallback = ({ data }) => {
        setSubmitting(false);
        setSettlementGroup(camelCaseRecursive(data));
        if (currentStep === 1) {
          dispatch(sendAlert({ message: 'Grupo de finiquito actualizado correctamente', kind: 'success' }));
          return;
        }
        setStep(step + 1);
      };
      updateSettlementGroupRequest(settlementGroup.id, payload);
      return;
    }
    payload.successCallback = ({ data }) => {
      setSubmitting(false);
      history.push(`/settlement_simulator/group/${data.id}/edit`);
      setSettlementGroup(camelCaseRecursive(data));
      setStep(step + 1);
    };
    createSettlementGroupRequest(payload);
  };

  const handleGoBackClick = currentStep => {
    if (currentStep === 0) {
      history.push('/settlement_simulator');
      return;
    }
    setStep(currentStep - 1);
  };

  const Component = componentMapping[step];

  useEffect(() => {
    fetchSettlementGroup();
  }, [fetchSettlementGroup]);
  return (
    <>
      {isLoading && (
        <div className="containerSpinnerLoad h-100 w-100">
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      {settlementGroup && !isLoading && (
        <Col style={{ backgroundColor: '#f5f5f5', marginTop: 35 }} xl={12}>
          <Row className="mt-2 mb-2">
            <Col md={1}>
              <Button variant="circle-dark" className="btn-circle mt-2" block onClick={() => handleGoBackClick(step)}>
                <Icon icon="chevron-back" />
              </Button>
            </Col>
            <h2 className="mt-2 text-center"> SIMULADOR DE FINIQUITO </h2>
          </Row>
          <Formik
            initialValues={initialValues(settlementGroup)}
            validationSchema={() => validationSchema({ currentStage: step })}
            onSubmit={(values, formikBag) => formRequest(values, formikBag, step)}
            enableReinitialize
          >
            <Form>
              <Component settlementGroup={settlementGroup} history={history} />
            </Form>
          </Formik>
        </Col>
      )}
    </>
  );
}
